export const MonthlyRevenueChart = {
    series: [{
        name: "Desktops",
        data: [10000, 12000, 80000, 15000, 12000, 60000],
    },],
    chart: {
        height: 300,
        type: "line",
        toolbar: {
            show: false,
        },
        zoom: {
            enabled: false,
        },
    },
    dataLabels: {
        enabled: false,
    },
    stroke: {
        curve: "smooth",
    },

    xaxis: {
        categories: [2016, 2017, 2018, 2019, 2020, 2021],
    },
}; 